import apiClient from "./api";
const DEPARTAMENTO_API_BASE_URL = "/departamentos";
class DepartamentoService {
  getDepartamentos() {
    return apiClient.get(DEPARTAMENTO_API_BASE_URL);
  }
  agregarDepartamento(departamento) {
    return apiClient.post(DEPARTAMENTO_API_BASE_URL, departamento);
  }
  updateDepartamento(departamento, departamentoId) {
    return apiClient.put(DEPARTAMENTO_API_BASE_URL + "/" + departamentoId, departamento);
  }
  deleteDepartamento(departamentoId) {
    return apiClient.delete(DEPARTAMENTO_API_BASE_URL + "/" + departamentoId);
  }
  async getDepartamentosPorSucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${DEPARTAMENTO_API_BASE_URL}/sucursal/${sucursalId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new DepartamentoService();